import React, { useEffect, useState } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { DatePicker } from "antd";
import moment from "moment";
import { convertTime12to24 } from "helpers/timeStringToFloat";
import Spinner from "components/common/Spinner";
import {
    profileGetVacationsById,
    profileCreateVacations,
    profileUpdateVacations
} from "api/menu/profile/actions";
import SearchSelect from "../../common/SearchSelect";

const VacationEdit = (props) => {
    const dateFormat = "YYYY-MM-DD";

    const {
        loading,
        id,
        singleVacations,
        profileGetVacationsById,
        profileCreateVacations,
        profileUpdateVacations,
        onCancel
    } = props;

    const [timeList, setTimeList] = useState([]);
    const [isFullDay, setIsFullDay] = useState(true);
    const [userVacation, setUserVacation] = useState({
        startDate: moment(moment().format(dateFormat)),
        endDate: moment(moment().format(dateFormat)),
        isVacation: true,
        isDeleted: false
    });

    const onChange = (arr) => {
        const newUserVacation = Object.assign({}, userVacation);
        arr.forEach(item => {
            // eslint-disable-next-line no-empty
            if (item.value) {

                // eslint-disable-next-line no-empty
            } else {

            }
            newUserVacation[item.key] = item.value;
        });
        setUserVacation(newUserVacation);
    },
    onChangeDate = time => {
        const newUserVacation = Object.assign({}, userVacation);

        newUserVacation[time.key] = `${moment(userVacation.startDate).format(`${dateFormat}`)}T${moment(time.value, "H:mm").format("HH:mm:ss")}`;

        setUserVacation(newUserVacation);
    },
    onSave = () => {
        const vacationsData = {
            id: id || 0,
            workerId: userVacation.workerId || 0,
            startDate: `${moment(userVacation.startDate).format(`${dateFormat}`)}T${moment(userVacation.startDate).format("HH:mm:00")}`,
            endDate: `${moment(userVacation.endDate).format(`${dateFormat}`)}T${moment(userVacation.endDate).format("HH:mm:00")}`,
            isVacation: userVacation.isVacation,
            isDeleted: userVacation.isDeleted || false
        };
        if (id) {
            profileUpdateVacations(id, vacationsData, onCancel);
        } else {
            profileCreateVacations(vacationsData, onCancel);
        }
    },
    onChangeDayLong = (value) => {
        if (!value) {
            onChange([{
                key: "endDate",
                value: moment(userVacation.startDate).valueOf()
            }]);
        }
        setIsFullDay(value);
    };

    useEffect(() => {
        if (id) {
            profileGetVacationsById(id);
        }
    }, [profileGetVacationsById, id]);

    useEffect(() => {
        if (Object.keys(singleVacations).length) {
            const diffHours = moment(singleVacations.endDate)
                .diff(singleVacations.startDate, "hours");

            if (diffHours < 24) {
                setIsFullDay(false);
            }
        }
    }, [userVacation]);
    useEffect(() => {
        if (Object.keys(singleVacations).length) {
            setUserVacation(singleVacations);
        }
    }, [singleVacations]);

    // Unmount
    useEffect(() => () => {
        profileGetVacationsById(false);
    }, [profileGetVacationsById]);
    useEffect(() => {
        const interval = 15;
        const times = [];
        let startTime = 360;
        const format = [" AM", " PM"];
        const zero = "0";

        // eslint-disable-next-line no-plusplus
        for (let i = 0; startTime < 24 * 60; i++) {
            const currentTime = {};
            const hh = Math.floor(startTime / 60);
            const mm = (startTime % 60);

            let to12Hour = hh % 12;
            if (to12Hour === 0) to12Hour = 12;
            currentTime.label = `${(to12Hour).toString().slice(-2)}:${(zero + mm).slice(-2)}${format[Math.floor(hh / 12)]}`;
            currentTime.value = `${convertTime12to24(currentTime.label)}:00`;
            startTime += interval;
            times.push(currentTime);
        }
        setTimeList(times);
    }, [userVacation]);

    return (
        <div className="position-relative">
            {!loading || <Spinner />}

            <div className="align-items-center d-flex form-group form-inline">
                <label className="mr-5">Type</label>
                <div className="mt-0 mr-3 form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="type-vacation"
                        checked={!!userVacation.isVacation}
                        onChange={() => {
                            onChange([{
                                key: "isVacation",
                                value: true
                            }]);
                        }}
                    />
                    <label className="form-check-label" htmlFor="type-vacation">
                        Vacation
                    </label>
                </div>
                <div className="mt-0 mr-3 form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="type-off"
                        checked={!userVacation.isVacation}
                        onChange={() => {
                            onChange([{
                                key: "isVacation",
                                value: false
                            }]);
                        }}
                    />
                    <label className="form-check-label" htmlFor="type-off">
                        Off
                    </label>
                </div>
            </div>
            <div className="align-items-center d-flex form-group form-inline">
                <label className="mr-5 invisible">Limit</label>
                <div className="mt-0 mr-3 form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="day-full"
                        checked={isFullDay}
                        onChange={() => onChangeDayLong(true)}
                    />
                    <label className="form-check-label" htmlFor="day-full">
                        Full Day
                    </label>
                </div>
                <div className="mt-0 mr-3 form-check">
                    <input
                        className="form-check-input"
                        type="radio"
                        id="day-partial"
                        checked={!isFullDay}
                        onChange={() => onChangeDayLong(false)}
                    />
                    <label className="form-check-label" htmlFor="day-partial">
                        Partial Day
                    </label>
                </div>
            </div>
            <div className="form-group">
                <label>From</label>
                <DatePicker
                    className="d-block"
                    format="YYYY-MM-DD"
                    value={userVacation.startDate ? moment(userVacation.startDate) : null}
                    onChange={date => {
                        onChange([{
                            key: "startDate",
                            value: moment(date).valueOf()
                        }, {
                            key: "endDate",
                            value: (userVacation.endDate
                                && moment(userVacation.endDate).valueOf() < moment(date).valueOf()
                                ? moment(date).valueOf()
                                : moment(userVacation.endDate).valueOf()
                            )
                        }]);
                    }}
                    disabledDate={current => current && current <= moment().subtract(1, "days")}
                />
            </div>
            {isFullDay ?
                <div className="form-group">
                    <label>To</label>
                    <DatePicker
                        className="d-block"
                        format="YYYY-MM-DD"
                        value={userVacation.endDate ? moment(userVacation.endDate) : null}
                        onChange={date => {
                            onChange([{
                                key: "endDate",
                                value: moment(date).valueOf()
                            }]);
                        }}
                        disabledDate={current => {
                            if (userVacation.startDate) {
                                return current && current < userVacation.startDate;
                            }
                            return current && current <= moment().subtract(1, "days");
                        }}
                    />
                </div>
                :
                <div className="form-inline">
                    <div className="form-group mr-3">
                        <label>From</label>
                        <SearchSelect
                            isLoading={false}
                            className={"w-150"}
                            isClearable={false}
                            options={timeList}
                            value={userVacation.startDate ?
                                // eslint-disable-next-line max-len
                                timeList.find(item => userVacation.startDate.toString().includes(item.value)) : null}
                            onChange={time => {
                                onChangeDate({
                                    key: "startDate",
                                    value: time.value
                                });
                            }}
                        />
                    </div>
                    <div className="form-group">
                        <label>To</label>
                        <SearchSelect
                            isLoading={false}
                            className={"w-150"}
                            isClearable={false}
                            options={timeList}
                            value={userVacation.endDate ?
                                // eslint-disable-next-line max-len
                                timeList.find(item => userVacation.endDate.toString().includes(item.value)) : null}
                            onChange={time => {
                                onChangeDate({
                                    key: "endDate",
                                    value: time.value
                                });
                            }}
                        />
                    </div>
                </div>
            }

            <div className="text-right">
                <button
                    className="btn btn-success"
                    onClick={onSave}
                >
                    Save
                </button>
            </div>
        </div>
    );
};


VacationEdit.propTypes = {
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
};

const mapStateToProps = state => ({
    loading: state.profile.loading,
    specialAvailability: state.profile.specialAvailability,
    singleVacations: state.profile.singleVacations,
});

const mapStateToDispatch = dispatch => ({
    profileGetVacationsById: bindActionCreators(profileGetVacationsById, dispatch),
    profileCreateVacations: bindActionCreators(profileCreateVacations, dispatch),
    profileUpdateVacations: bindActionCreators(profileUpdateVacations, dispatch),
});


export default connect(
    mapStateToProps,
    mapStateToDispatch
)(VacationEdit);
